import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FilterModalModule } from '@helios/filter-modal'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { RowActionsModule, TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  CheckboxModule,
  DateModule,
  DatepickerModule,
  DaterangeModule,
  NfFormsModule,
  ToggleModule,
} from '@northfork/ng-basics'
import { AccruedInterestGridComponent } from './components/accrued-interest-grid/accrued-interest-grid.component'
import { AccruedInterestPropertiesComponent } from './components/accrued-interest-properties/accrued-interest-properties.component'
import { CouponRateHistoryGridComponent } from './components/coupon-rate-history-grid/coupon-rate-history-grid.component'
import { DistributionsAdvancedOptionsComponent } from './components/distributions-advanced-options/distributions-advanced-options.component'
import { DistributionsGridComponent } from './components/distributions-grid/distributions-grid.component'
import { DistributionsPropertiesComponent } from './components/distributions-properties/distributions-properties.component'
import { DividendHistoryGridComponent } from './components/dividend-history-grid/dividend-history-grid.component'
import { FactorHistoryGridComponent } from './components/factor-history-grid/factor-history-grid.component'
import { AddMmfCalendarComponent } from './components/mmf-settings-grid/add-mmf-calendar/add-mmf-calendar.component'
import { MmfSettingsGridComponent } from './components/mmf-settings-grid/mmf-settings-grid.component'
import { DistributionsPanelComponent } from './distributions-panel.component'
import { DistributionsService } from './services/distributions.service'
import { HttpDistributionsService } from './services/http-distributions.service'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbNavModule,
    NgbTooltipModule,
    GenericComponentsModule,
    ResizeHandleModule,
    ToggleModule,
    ReactiveFormsModule,
    RowActionsModule,
    // Northfork Modules
    CheckboxModule,
    TableLayoutModule,
    NfFormsModule,
    DaterangeModule,
    FilterModalModule,
    DateModule,
    DatepickerModule,
    NgSelectModule,
  ],
  declarations: [
    DistributionsPanelComponent,
    DistributionsGridComponent,
    DistributionsPropertiesComponent,
    AccruedInterestGridComponent,
    FactorHistoryGridComponent,
    AccruedInterestPropertiesComponent,
    DistributionsAdvancedOptionsComponent,
    CouponRateHistoryGridComponent,
    DividendHistoryGridComponent,
    MmfSettingsGridComponent,
    AddMmfCalendarComponent,
  ],
  exports: [DistributionsPanelComponent],
  providers: [
    { useClass: HttpDistributionsService, provide: DistributionsService },
  ],
})
export class DistributionsModule {}

export { DistributionsPanelComponent }
